import store from '../store/index';

let configArr = [
  {
    href: 'localhost',
    title: '同江市农村产权交易服务中心',
    citytitle: '同江市',
    tId: '508831a250994107b91ab4f587d7a36a',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '230881',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false]
    // href: 'localhost',
    // title: '抚远市农村产权交易服务中心',
    // tId: 'c6e40fcf1705445d840ded2194b4fe8b',
    // skinStyleCode: '',
    // areaCode: '230883',
    // temAreaCode: '', // 模板那儿新增编辑用于回显的areaCode，有层级要求；
    // areaLevel: 1, // 模板那儿新增编辑，请求时的level层级，默认都赋值1；
    // startLevel: '1', // 从哪级开始显示0：中国、1：省、2：市、3：县、4：镇、5：村
    // showLevel: '5', // 结束显示到哪级 0：中国、1：省、2：市、3：县、4：镇、5：村
    // showLevelList: [false, false, false, false, false, false], // 依次为：中国、省、市、区县、镇乡、村的选择框，是否展示；
    // loginLogo: ''
  },
  {
    href: 'tongjiang',
    title: '同江市农村产权交易服务中心',
    citytitle: '同江市',
    tId: '508831a250994107b91ab4f587d7a36a',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '230881',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'huachuan',
    title: '桦川县农村产权交易服务中心',
    citytitle: '桦川县',
    tId: '6f7ffc115ff84369b51043fbbf976c9b',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '230826',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'fuyuan',
    title: '抚远市农村产权交易服务中心',
    citytitle: '抚远市',
    tId: 'c6e40fcf1705445d840ded2194b4fe8b',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '230883',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'jieshou',
    title: '界首市农村产权交易服务中心',
    citytitle: '界首市',
    tId: 'a501247a7e004b9e8439b057e56c4b39',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '341282',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'yingshang',
    title: '颍上县农村产权交易中心',
    citytitle: '颍上县',
    tId: '7fc6a1e4fe8443608a37731be5d8a8c1',
    logoImage: require('../assets/images/logo/yingshang.png'),
    skinStyleCode: '',
    areaCode: '341226',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'tiandong',
    title: '广西田东农村产权交易服务中心',
    citytitle: '广西田东',
    tId: 'bc3192ec4dbf466eb0e90caa2a036781',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '451022',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'linquan',
    title: '临泉县农村产权交易服务中心',
    citytitle: '安徽临泉',
    tId: '9ac76f26c8fa4298b2ceefddaa2f30e9',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '341221',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'nanyang',
    title: '西峡县农村产权交易服务中心',
    citytitle: '河南南阳',
    tId: 'efe4187a3c92446f95f62f90414ae5eb',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '4113',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'guizhou',
    title: '贵州省农村产权交易服务平台',
    citytitle: '贵州省',
    tId: '489f0005ea694ae580a89987f0680710',
    logoImage: require('../assets/images/logo/default.png'),
    skinStyleCode: '',
    areaCode: '520101',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'hnnt',
    title: '河南省农村产权交易市场',
    citytitle: '河南省',
    tId: 'ada317bcaa3247abb887e77042bc7104',
    logoImage: require('../assets/images/logo/hnnt.png'),
    skinStyleCode: '',
    areaCode: '41',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  }
];

export function getComParams () {
  let localHost = window.location.host;
  const tenantParams = configArr.find(item => localHost.includes(item.href));
  store.commit('SET_TENANT_PARAMS', tenantParams || {}); // 存储租户id

  // 设置网页标题
  let href = window.location.origin;
  let env = '';
  if (href.indexOf('dev') >= 0 || href.indexOf('http://localhost') >= 0) {
    env = '(开发)';
  } else if (href.indexOf('test') >= 0) {
    env = '(测试)';
  } else if (href.indexOf('jlncjy.cn') >= 0 || href.indexOf('stage') >= 0) {
    env = '(准生产)';
  }
  document.title = env + tenantParams.title;
}

export function getComParamsTitle () {
  let localHost = window.location.host;
  const tenantParams = configArr.find(item => localHost.includes(item.href));
  return tenantParams.citytitle;
}
